import { __cFlashSaleService } from '@/services/client/__c.flash-sale.service'
import { useQuery } from '@tanstack/react-query'

export const useFlashSale = () => {
  return useQuery({
    queryKey: ['flash-sale'],
    queryFn: () => __cFlashSaleService.getFlashSales(),
  })
}

export const useProductFlashSale = (productId: string) => {
  const { data: flashSaleData } = useFlashSale()

  if (!productId || !flashSaleData) return null

  // Kiểm tra trong flash sale hiện tại
  if (flashSaleData.current && flashSaleData.current.length > 0) {
    // Tìm kiếm sản phẩm trong tất cả các flash sale đang diễn ra
    for (const currentFlashSale of flashSaleData.current) {
      const productInCurrent = currentFlashSale.products?.find(
        (product: { product_id: string }) => product.product_id === productId
      )

      console.log(currentFlashSale)

      if (productInCurrent) {
        return {
          startsAt: new Date(currentFlashSale.starts_at),
          endsAt: new Date(currentFlashSale.ends_at),
          product: productInCurrent,
        }
      }
    }
  }

  // Kiểm tra trong flash sale sắp tới
  if (flashSaleData.next && flashSaleData.next.length > 0) {
    // Tìm kiếm sản phẩm trong tất cả các flash sale sắp diễn ra
    for (const nextFlashSale of flashSaleData.next) {
      const productInNext = nextFlashSale.products?.find(
        (product: { product_id: string }) => product.product_id === productId
      )

      if (productInNext) {
        return {
          endsAt: new Date(nextFlashSale.ends_at),
          product: productInNext,
        }
      }
    }
  }

  return null
}
